<form nz-form [formGroup]="activityFrom" (ngSubmit)="onSubmit()">
  <div nz-row>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label  [nzSm]="6" [nzXs]="24" nzFor="ClgCode">No</nz-form-label>
        <nz-form-control  [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="ClgCode" id="ClgCode" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label nz-col [nzSm]="6" [nzXs]="24" nzFor="Action">Activity</nz-form-label>
        <nz-form-control nz-col [nzSm]="14" [nzXs]="24">
          <nz-select formControlName="Action">
            <nz-option [nzValue]="item.key" [nzLabel]="item.value" *ngFor="let item of activityAction|keyvalue"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="CardCode">BP Code</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="CardCode" id="CardCode" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="CntctSbjct">Subject</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="CntctSbjct" id="CntctSbjct" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="CardName"
          >Costumer Name</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="CardName" id="CardName" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ContactPer"
          >Contact Person</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="ContactPer" id="ContactPer" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Tel">Tel</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="Tel" id="Tel" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="AttendUser"
          >Assigned To</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="AttendUser" id="AttendUser" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="AssignedBy"
          >Assigned By</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="AssignedBy" id="AssignedBy" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzLg]="{ span:11, offset: 1 }">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="U_ITM_BWEB_READ">Is Read</nz-form-label>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="U_ITM_BWEB_READ" id="U_ITM_BWEB_READ" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>



  <nz-tabset nzType="card">
    <nz-tab [nzTitle]="'General'">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Details"
        >Remark</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="Details" id="Details" />
        </nz-form-control>
      </nz-form-item>

      <div nz-row>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Recontact"
              >start Date</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="Recontact" id="Recontact" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="BeginTime"
              >start Time</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="BeginTime" id="BeginTime" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="endDate"
              >End Date</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="endDate" id="endDate" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ENDTime"
              >End Time</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="ENDTime" id="ENDTime" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Priority"
              >Priority</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-select formControlName="Priority">
                <nz-option [nzValue]="item.key" [nzLabel]="item.value" *ngFor="let item of priority|keyvalue"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Closed"
              >Closed</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-select formControlName="Closed">
                <nz-option [nzValue]="item.key" [nzLabel]="item.value" *ngFor="let item of YesNO|keyvalue"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="CloseDate"
              >Close Date</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="CloseDate" id="CloseDate" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="U_ITM_CUSTOM_STATUS"
              >ITM Status</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="U_ITM_CUSTOM_STATUS" id="U_ITM_CUSTOM_STATUS" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="inactive"
              >Inactive</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-select formControlName="inactive">
                <nz-option [nzValue]="item.key" [nzLabel]="item.value" *ngFor="let item of YesNO|keyvalue"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="Reminder"
              >Reminder</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-select formControlName="Reminder">
                <nz-option [nzValue]="item.key" [nzLabel]="item.value" *ngFor="let item of YesNO|keyvalue"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="RemQty"
              >Reminder After</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="RemQty" id="RemQty" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzLg]="{ span:11, offset: 1 }">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="RemType"
              >Reminder Type</nz-form-label
            >
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input formControlName="RemType" id="RemType" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'Content'">
      <nz-form-item>
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="Notes" id="Notes" />
        </nz-form-control>
      </nz-form-item>
    </nz-tab>

    <nz-tab [nzTitle]="'Linked Document'">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="DocType"
          >Document Type</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="DocType" id="DocType" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="DocNum"
          >Document Number</nz-form-label
        >
        <nz-form-control [nzSm]="14" [nzXs]="24">
          <input nz-input formControlName="DocNum" id="DocNum" />
        </nz-form-control>
      </nz-form-item>
    </nz-tab>
  </nz-tabset>
</form>
